import React from 'react';

export default function ArticleSkeleton() {
  return (
    <div className="animate-pulse px-4 md:px-8 py-4">
      {/* Large title bar */}
      <div className="  h-12 w-3/4 mb-6 rounded" />

      {/* Date + Comments row */}
      <div className="flex items-center space-x-4 mb-6">
        <div className=" h-4 w-32 rounded" />
        <div className="h-4 w-16 rounded" />
      </div>

      {/* Hero image / big placeholder */}
      <div className=" h-80 w-full mb-6 rounded" />

      {/* Some paragraph lines */}
      <div className=" h-4 w-5/6 mb-3 rounded" />
      <div className="h-4 w-3/4 mb-3 rounded" />
      <div className="h-4 w-2/3 mb-3 rounded" />
      <div className="h-4 w-4/5 mb-3 rounded" />

      {/* Extra spacing for a nice sized skeleton */}
      <div className=" h-4 w-2/4 mb-3 rounded" />
      <div className="h-4 w-3/4 mb-3 rounded" />
      <div className="h-4 w-5/6 mb-3 rounded" />
    </div>
  );
}
